import React from "react";
import { default as MUITextField } from "@mui/material/TextField";
import styled from "styled-components";

const StyledMUITextField = styled(MUITextField)`
  div {
    border-radius: 8px !important;
  }

  textarea:focus {
    border-bottom: none !important;
  }

  textarea {
    font-size: 14px;
  }

  fieldset {
    box-shadow: none !important;
    background: transparent !important;
  }

  .MuiInputBase-root:not(.MuiAutocomplete-inputRoot):not(.Mui-disabled)
    fieldset {
    border: 1px solid var(--colorBorder) !important;
  }

  .MuiInputBase-root.Mui-focused:not(.Mui-disabled) fieldset {
    border: 2px solid var(--primaryColor) !important;
  }

  &:hover
    .MuiInputBase-root:not(.Mui-focused):not(.MuiAutocomplete-inputRoot):not(
      .Mui-disabled
    )
    fieldset {
    border: 2px solid var(--colorBorder) !important;
  }
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "300px")};
`;

export const TextFieldMultiline = ({
  defaultValue,
  value,
  placeholder,
  label,
  onBlur,
  onChange,
  minRows,
  fullWidth,
  helperText,
  error = false,
  FormHelperTextProps,
  inputProps,
  disabled,
  id,
  sx,
}) => {
  return (
    <StyledMUITextField
      defaultValue={defaultValue}
      value={value}
      placeholder={placeholder}
      label={label}
      onBlur={onBlur}
      onChange={onChange}
      minRows={minRows}
      fullWidth={fullWidth}
      helperText={helperText}
      error={error}
      FormHelperTextProps={FormHelperTextProps}
      inputProps={inputProps}
      disabled={disabled}
      {...(sx != null ? { sx } : {})}
      id={id}
      variant="outlined"
      multiline
    />
  );
};
